// dna_frontend/src/pages/AdminDuyetXoa.js
// (Copy và thay thế toàn bộ file)

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import {
  Container, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button, CircularProgress, Box,
  TablePagination, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, TextField, Checkbox, Toolbar,
  // (*** MỚI (YC 3) ***)
  Select, MenuItem, FormControl, InputLabel, Grid
} from '@mui/material';

// (*** MỚI (YC 3) ***)
// Lấy từ RaSoatModal.js
const LY_DO_FILTER_OPTIONS = [
  { key: '', value: '-- Tất cả lý do --' },
  { key: 'Đã chết', value: 'Đã chết' },
  { key: 'Sai diện', value: 'Sai diện' },
  { key: 'Thân nhân "thừa" (thân nhân 3, 4, 5...)', value: 'Thân nhân "thừa" (thân nhân 3, 4, 5...)' },
  { key: 'Liệt sĩ đã tìm thấy mộ', value: 'Liệt sĩ đã tìm thấy mộ' },
  { key: 'khac', value: 'Khác (Không thuộc các lý do trên)' },
];

function AdminDuyetXoa() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [selectedIds, setSelectedIds] = useState([]);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openConfirmRestore, setOpenConfirmRestore] = useState(false);
  const [selectedThanNhan, setSelectedThanNhan] = useState(null);
  const [restoreReason, setRestoreReason] = useState('');
  const [isBulkAction, setIsBulkAction] = useState(false);
  
  // (*** MỚI (YC 3) ***)
  const [xaList, setXaList] = useState([]);
  const [filters, setFilters] = useState({
      ten_tn: '',
      xa_id: '',
      ly_do: ''
  });

  useEffect(() => {
    // Tải danh sách xã
    api.get('/data/xaphuong')
      .then(res => setXaList(res.data))
      .catch(err => console.error("Lỗi tải danh sách xã"));
      
    fetchData(page, limit, filters);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]); // Chỉ fetch lại khi phân trang

  const fetchData = async (page, limit, currentFilters) => {
    setLoading(true);
    setError('');
    try {
      // (*** SỬA (YC 3) ***) Gửi filter
      const params = new URLSearchParams({
          page: page + 1,
          limit: limit,
          ...currentFilters
      });
      const res = await api.get(`/data/de-nghi-xoa?${params.toString()}`);
      
      setList(res.data.data);
      // (SỬA) Lấy totalItems từ totalPages * limit
      const calculatedTotal = (res.data.totalPages || 0) * (res.data.limit || limit);
      setTotalItems(calculatedTotal > 0 ? calculatedTotal : (res.data.data.length || 0));

      if(res.data.currentPage) {
        setPage(res.data.currentPage - 1);
      }
      setSelectedIds([]);
    } catch (err) {
      console.error(err);
      setError('Không thể tải danh sách đề nghị xóa.');
    } finally {
      setLoading(false);
    }
  };
  
  // (SỬA) fetchAndRecalculateTotal đã bị xóa, gộp vào handleChangePage
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData(newPage, limit, filters); // (SỬA) Gửi filter
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setLimit(newLimit);
    setPage(0); 
    fetchData(0, newLimit, filters); // (SỬA) Gửi filter
  };
  
  // (*** MỚI (YC 3) ***)
  const handleFilterChange = (e) => {
      setFilters({ ...filters, [e.target.name]: e.target.value });
  };
  
  const handleSearch = () => {
      setPage(0);
      fetchData(0, limit, filters);
  };
  
  const handleReset = () => {
      const emptyFilters = { ten_tn: '', xa_id: '', ly_do: '' };
      setFilters(emptyFilters);
      setPage(0);
      fetchData(0, limit, emptyFilters);
  };


  // (Logic chọn hàng giữ nguyên)
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelectedIds = list.map((n) => n.id);
      setSelectedIds(newSelectedIds);
      return;
    }
    setSelectedIds([]);
  };
  const handleClick = (event, id) => {
    const selectedIndex = selectedIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedIds, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedIds.slice(1));
    } else if (selectedIndex === selectedIds.length - 1) {
      newSelected = newSelected.concat(selectedIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedIds.slice(0, selectedIndex),
        selectedIds.slice(selectedIndex + 1),
      );
    }
    setSelectedIds(newSelected);
  };
  const isSelected = (id) => selectedIds.indexOf(id) !== -1;
  const numSelected = selectedIds.length;
  const rowCount = list.length;


  // (Logic Dialog giữ nguyên)
  const handleOpenConfirmDelete = (tn) => {
    setIsBulkAction(false); 
    setSelectedThanNhan(tn);
    setOpenConfirmDelete(true);
  };
  const handleOpenBulkDelete = () => {
    setIsBulkAction(true); 
    setOpenConfirmDelete(true);
  };
  const handleCloseConfirmDelete = () => {
    setOpenConfirmDelete(false);
    setSelectedThanNhan(null);
  };
  const handleOpenConfirmRestore = (tn) => {
    setIsBulkAction(false);
    setSelectedThanNhan(tn);
    setRestoreReason('');
    setOpenConfirmRestore(true);
  };
  const handleOpenBulkRestore = () => {
    setIsBulkAction(true);
    setRestoreReason('');
    setOpenConfirmRestore(true);
  };
  const handleCloseConfirmRestore = () => {
    setOpenConfirmRestore(false);
    setSelectedThanNhan(null);
  };

  // (Logic Xử lý giữ nguyên)
  const handleConfirmDelete = async () => {
    try {
      if (isBulkAction) {
        await api.post(`/than-nhan/admin/delete-bulk`, { ids: selectedIds });
      } else {
        await api.delete(`/than-nhan/admin/delete/${selectedThanNhan.id}`);
      }
      handleCloseConfirmDelete();
      fetchData(page, limit, filters); // (SỬA) Gửi filter
    } catch (err) {
      console.error(err);
      setError('Lỗi khi xóa mềm thân nhân.');
    }
  };
  const handleConfirmRestore = async () => {
    try {
      if (isBulkAction) {
        await api.post(`/than-nhan/admin/restore-review-bulk`, {
            ids: selectedIds,
            ghi_chu_admin: restoreReason
        });
      } else {
        await api.put(`/than-nhan/admin/restore-review/${selectedThanNhan.id}`, {
          ghi_chu_admin: restoreReason
        });
      }
      handleCloseConfirmRestore();
      fetchData(page, limit, filters); // (SỬA) Gửi filter
    } catch (err) {
      console.error(err);
      setError('Lỗi khi từ chối đề nghị xóa.');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Duyệt Đề Nghị Xóa
      </Typography>
      
      {/* (*** MỚI (YC 3) ***) Bộ lọc */}
      <Paper sx={{ p: 2, mb: 2, background: '#f9f9f9' }}>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
                <TextField
                    label="Tìm theo Tên Thân nhân"
                    name="ten_tn"
                    value={filters.ten_tn}
                    onChange={handleFilterChange}
                    fullWidth
                    size="small"
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small">
                    <InputLabel id="xa-filter-label">Lọc theo Xã</InputLabel>
                    <Select
                        labelId="xa-filter-label"
                        label="Lọc theo Xã"
                        name="xa_id"
                        value={filters.xa_id}
                        onChange={handleFilterChange}
                    >
                        <MenuItem value=""><em>-- Tất cả Xã --</em></MenuItem>
                        {xaList.map((xa) => (
                            <MenuItem key={xa.id} value={xa.id}>{xa.ten_xa}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
                 <FormControl fullWidth size="small">
                    <InputLabel id="lydo-filter-label">Lọc theo Lý do</InputLabel>
                    <Select
                        labelId="lydo-filter-label"
                        label="Lọc theo Lý do"
                        name="ly_do"
                        value={filters.ly_do}
                        onChange={handleFilterChange}
                    >
                        {LY_DO_FILTER_OPTIONS.map((opt) => (
                            <MenuItem key={opt.key} value={opt.key}>{opt.value}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
                <Box sx={{display: 'flex', gap: 1}}>
                    <Button variant="contained" onClick={handleSearch} disabled={loading}>Tìm</Button>
                    <Button variant="outlined" onClick={handleReset} disabled={loading}>Reset</Button>
                </Box>
            </Grid>
        </Grid>
      </Paper>


      {error && <Typography color="error">{error}</Typography>}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        
          {/* (Toolbar hàng loạt giữ nguyên) */}
          <Toolbar
            sx={{
              pl: { sm: 2 },
              pr: { xs: 1, sm: 1 },
              ...(numSelected > 0 && {
                bgcolor: (theme) => theme.palette.grey[200],
              }),
            }}
          >
            {numSelected > 0 ? (
              <Typography
                sx={{ flex: '1 1 100%' }}
                color="inherit"
                variant="subtitle1"
                component="div"
              >
                Đã chọn {numSelected}
              </Typography>
            ) : (
              <Typography sx={{ flex: '1 1 100%' }} variant="h6" component="div">
                Danh sách
              </Typography>
            )}

            {numSelected > 0 && (
              <Box sx={{display: 'flex', gap: 1}}>
                <Button variant='contained' color='error' size='small' onClick={handleOpenBulkDelete}>
                  Duyệt Xóa (Loạt)
                </Button>
                <Button variant='outlined' color='secondary' size='small' onClick={handleOpenBulkRestore}>
                  Từ chối (Loạt)
                </Button>
              </Box>
            )}
          </Toolbar>
        
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={rowCount > 0 && numSelected === rowCount}
                      onChange={handleSelectAllClick}
                      inputProps={{ 'aria-label': 'chọn tất cả' }}
                    />
                  </TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Họ tên</TableCell>
                  <TableCell>Năm sinh</TableCell>
                  <TableCell>CCCD</TableCell>
                  <TableCell>Địa chỉ</TableCell>
                  <TableCell>Xã</TableCell>
                  <TableCell>Lý do đề nghị xóa</TableCell>
                  <TableCell>Hành động (Đơn lẻ)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.length === 0 ? (
                    <TableRow>
                        <TableCell colSpan={9} sx={{textAlign: 'center'}}>
                            Không có đề nghị xóa nào khớp với bộ lọc.
                        </TableCell>
                    </TableRow>
                ) : (
                    list.map((tn) => {
                      const isItemSelected = isSelected(tn.id);
                      return (
                      <TableRow 
                        hover 
                        key={tn.id}
                        selected={isItemSelected}
                        onClick={(event) => handleClick(event, tn.id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                            <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': `checkbox-${tn.id}` }}
                            />
                        </TableCell>
                        <TableCell>{tn.id}</TableCell>
                        <TableCell>{tn.ho_ten}</TableCell>
                        <TableCell>{tn.nam_sinh}</TableCell>
                        <TableCell>{tn.cccd}</TableCell>
                        <TableCell>{tn.dia_chi}</TableCell>
                        <TableCell>{tn.ten_xa}</TableCell>
                        <TableCell sx={{ color: 'red', fontStyle: 'italic', minWidth: '200px' }}>
                          {tn.ghi_chu || '(Không có lý do)'}
                        </TableCell>
                        <TableCell>
                          <Box 
                            sx={{ display: 'flex', gap: 1, minWidth: '200px' }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              onClick={() => handleOpenConfirmDelete(tn)}
                            >
                              Duyệt Xóa
                            </Button>
                            <Button
                              variant="outlined"
                              color="secondary"
                              size="small"
                              onClick={() => handleOpenConfirmRestore(tn)}
                            >
                              Từ chối
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )})
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={totalItems}
            rowsPerPage={limit}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}

      {/* (Dialogs giữ nguyên) */}
      <Dialog open={openConfirmDelete} onClose={handleCloseConfirmDelete}>
        <DialogTitle>Xác nhận Xóa (Xóa mềm)</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isBulkAction ? (
                `Bạn có chắc muốn xóa mềm ${numSelected} thân nhân đã chọn?`
            ) : (
                `Bạn có chắc muốn xóa mềm thân nhân <strong>${selectedThanNhan?.ho_ten}</strong> (ID: ${selectedThanNhan?.id})?`
            )}
            <br />
            Họ sẽ bị ẩn khỏi hệ thống nhưng vẫn còn trong CSDL.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDelete}>Hủy</Button>
          <Button onClick={handleConfirmDelete} color="error">
            Xác nhận Xóa
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openConfirmRestore} onClose={handleCloseConfirmRestore}>
        <DialogTitle>Từ chối Đề nghị Xóa</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isBulkAction ? (
                `Bạn có chắc muốn từ chối đề nghị xóa cho ${numSelected} thân nhân đã chọn?`
            ) : (
                `Bạn có chắc muốn từ chối đề nghị xóa thân nhân <strong>${selectedThanNhan?.ho_ten}</strong>?`
            )}
            <br />
            Hệ thống sẽ trả họ về trạng thái "Chưa rà soát".
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Ghi chú của Admin (tùy chọn)"
            type="text"
            fullWidth
            variant="standard"
            value={restoreReason}
            onChange={(e) => setRestoreReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmRestore}>Hủy</Button>
          <Button onClick={handleConfirmRestore} color="primary">
            Xác nhận Từ chối
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default AdminDuyetXoa;